// Copyright (c) 2017 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import t from 'tcomb';

const Rate = t.struct({
    account: t.String,
    currentRate: t.maybe(t.Number),
    description: t.String,
    isRateDifferenceLarge: t.Boolean,
    laborSubType: KeyValuePair,
    laborType: KeyValuePair,
    reasonForChange: t.String,
    requestedRate: t.maybe(t.Number)
}, {
    name: 'Rate',
    strict: true
});

export const getDefaultState = () => new Rate({
    account: '',
    currentRate: 0,
    description: '',
    isRateDifferenceLarge: false,
    laborSubType: getKeyValuePairDefaultState(),
    laborType: getKeyValuePairDefaultState(),
    reasonForChange: '',
    requestedRate: 0
});

export default Rate;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/rate.js